import { useTranslation } from 'react-i18next';
import { DataPackage } from '../../types';

export function DataPackageSelect(props: {
    selectedDataPackage: DataPackage | null;
    setSelectedDatapackage: (dp: DataPackage) => void;
    dataPackageMap: Record<string, DataPackage>;
    dataPackages: DataPackage[];
}) {
    const { t, i18n } = useTranslation();
    const selectDataPackageDescription =
        props.selectedDataPackage?.description?.[i18n.language] ??
        props.selectedDataPackage?.description?.['sv'];

    return (
        <>
            <select
                aria-label={t('valj-datapaket')}
                className="select select-primary w-full"
                value={props.selectedDataPackage?.id ?? 'placeholder'}
                style={{
                    opacity: props.selectedDataPackage ? 1 : 0.6,
                }}
                onChange={(e) => {
                    const targetDataPackage =
                        props.dataPackageMap[e.target.value];
                    props.setSelectedDatapackage(targetDataPackage);
                }}
            >
                <option disabled value="placeholder">
                    {t('custom-package')}
                </option>
                {props.dataPackages.map((dp) => (
                    <option key={dp.id} value={dp.id}>
                        {dp.name[i18n.language] ?? dp.name['sv']}
                    </option>
                ))}
            </select>
            {selectDataPackageDescription && (
                <p className="text-sm">{selectDataPackageDescription}</p>
            )}
        </>
    );
}
